import React from 'react';
import { Box } from '@chakra-ui/core';

import { cloudfrontBaseUrl } from '../../lib/consts';

const AppStoreBadge = ({
  platform,
  zjcDirect = false,
  zmmDirect = false,
  height = 60
}) => {
  const width = (135 / 40) * height;
  let url;
  if (zjcDirect) {
    url =
      platform === 'ios'
        ? 'https://apps.apple.com/us/app/zeta-joint-card/id1493011848'
        : 'https://play.google.com/store/apps/details?id=com.askzeta.aZetaFi&hl=en_US&gl=US';
  } else if (zmmDirect) {
    url =
      platform === 'ios'
        ? 'https://apps.apple.com/us/app/zeta-money-manager/id1444687021'
        : 'https://play.google.com/store/apps/details?id=com.zetahelp.zeta&hl=en_US&gl=US';
  } else {
    url =
      platform === 'ios'
        ? 'https://apps.apple.com/us/developer/zeta-help-inc/id1444687020'
        : 'https://play.google.com/store/apps/developer?id=Zeta+Team&hl=en_US&gl=US';
  }

  const iosOriginal = `${cloudfrontBaseUrl}/app-store-icons/AppleBadge.png`;
  const androidOriginal = `${cloudfrontBaseUrl}/app-store-icons/googleplaybadge.png`;

  return (
    <Box>
      <a
        style={{
          display: 'inline-block',
          width: width,
          height: height
        }}
        href={url}
        target="_blank"
        rel="noreferrer"
      >
        <img
          src={platform === 'ios' ? iosOriginal : androidOriginal}
          alt="apple store or google play store"
        />
      </a>
    </Box>
  );
};

export default AppStoreBadge;
